import { useIntercomChat } from 'hooks/common';
import { useRole } from 'hooks/common/useRole';
import { SupportIcon_24 } from 'assets/icons';
import Button from 'components/Button';
import messages from './ContactSupportButton.messages';
import styles from './ContactSupportButton.module.css';

const ContactSupportButton = (): JSX.Element | null => {
  const { isAdmin } = useRole();
  const { showChat } = useIntercomChat();

  if (isAdmin) return null;

  return (
    <Button onClick={showChat} className={styles.button}>
      <SupportIcon_24 />
      {messages.contactSupport}
    </Button>
  );
};

export default ContactSupportButton;
